import { type ReactElement } from 'react';
import { useTheme } from '@doxyme/ui-foundation/theme';
import { useAppRouter } from '../../hooks/useAppRouter';
import {
  AUTH_TO_APP_BACKGROUND_TRANSITION_MS,
  getAuthFlowBackgroundColor,
  isAuthFlowPath,
} from '../../shared/authFlowBackground';
import { BodyBackgroundColor } from './bodyBackgroundColor';

/**
 * Auth funnel uses fullwhite; the rest of the app uses backend grey. Crossfades on
 * route change so the dashboard does not snap from white to grey.
 */
export const AppBodyBackground = (): ReactElement => {
  const theme = useTheme();
  const { pathname, asPath } = useAppRouter();
  const bodyColor = isAuthFlowPath(pathname, asPath)
    ? getAuthFlowBackgroundColor(theme)
    : theme.background.default.backend;

  return (
    <BodyBackgroundColor
      bodyColor={bodyColor}
      transitionMs={AUTH_TO_APP_BACKGROUND_TRANSITION_MS}
    />
  );
};
